import { render, staticRenderFns } from "./OrderLayout.vue?vue&type=template&id=d646bf10"
import script from "./OrderLayout.vue?vue&type=script&lang=js"
export * from "./OrderLayout.vue?vue&type=script&lang=js"
import style0 from "./OrderLayout.vue?vue&type=style&index=0&id=d646bf10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports